/**
 * User provide data
 *
 * @export
 * @class UserProvider
 */
var UserProvider = /** @class */ (function () {
    function UserProvider(userId, email, fullName, avatar, providerId, provider, accessToken, Location, isDesigner) {
        this.userId = userId;
        this.email = email;
        this.fullName = fullName;
        this.avatar = avatar;
        this.providerId = providerId;
        this.provider = provider;
        this.accessToken = accessToken;
        this.Location = Location;
        this.isDesigner = isDesigner;
    }
    return UserProvider;
}());
export { UserProvider };



//////////////////
// WEBPACK FOOTER
// ./src/core/domain/users/userProvider.ts
// module id = 644
// module chunks = 50